import axios from 'axios';
import LocalStorageService from '@/services/LocalStorageService';

export default function setup() {
  axios.interceptors.request.use((config) => {
    const token = LocalStorageService.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, (err) => Promise.reject(err));
}
